/* 🤖 this file was generated by svg-to-ts */
export const matIconGrid4X4: {
  name: 'grid-4-x-4';
  data: string;
} = {
  name: 'grid-4-x-4',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M22 7V5h-3V2h-2v3h-4V2h-2v3H7V2H5v3H2v2h3v4H2v2h3v4H2v2h3v3h2v-3h4v3h2v-3h4v3h2v-3h3v-2h-3v-4h3v-2h-3V7h3zM7 7h4v4H7V7zm0 10v-4h4v4H7zm10 0h-4v-4h4v4zm0-6h-4V7h4v4z"/></svg>`
};
